import { SnacksAction, SnacksActionTypes } from './snacksTypes';
import { OptionsObject } from 'notistack';

/**
 * Enfileira uma nova snackbar
 */
export function addSnackbar(
  message: string,
  options?: OptionsObject,
): SnacksAction {
  return {
    type: SnacksActionTypes.ADD_SNACKBAR,
    notification: {
      key: new Date().getTime() + Math.random(),
      message,
      options,
    },
  };
}

/**
 * Remove os dados de uma snackbar enfileirada da store.
 * Não remove o elemento do DOM.
 */
export function clearSnackbar(
  notificationKey: number,
): SnacksAction {
  return {
    type: SnacksActionTypes.CLEAR_SNACKBAR,
    notificationKey,
  };
}
